import React from "react";
import HomeComponent from "../components/Home/HomeComponent";

const PersonalPage = () => {
    return (
        <HomeComponent />
    );
};

export default PersonalPage;
